import 'core-js/actual';

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery.css';
window.lightGallery = lightGallery;

import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.min.css';
window.noUiSlider = noUiSlider;

import 'bxslider/dist/jquery.bxslider.js';
import 'bxslider/dist/jquery.bxslider.css';

import 'foundation-sites/dist/css/foundation-float.min.css';
import 'foundation-sites';

$(document).ready(function () {
    $(document).foundation();
});
